<template>
  <div>
    <div
      class="flex flex-col items-center justify-center success-page-alignment"
    >
      <div
        class="flex bg-green-50 w-24 h-24 justify-center p-6"
        style="border-radius: 50px"
      >
        <svg
          class="my-3"
          width="34"
          height="24"
          viewBox="0 0 34 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M33.0963 0.702944C34.0335 1.6402 34.0335 3.1598 33.0963 4.09706L13.8963 23.2971C12.959 24.2343 11.4394 24.2343 10.5022 23.2971L0.902162 13.6971C-0.0350959 12.7598 -0.0350959 11.2402 0.902162 10.3029C1.83942 9.36569 3.35902 9.36569 4.29627 10.3029L12.1992 18.2059L29.7022 0.702944C30.6394 -0.234315 32.159 -0.234315 33.0963 0.702944Z"
            fill="#065F46"
          />
        </svg>
      </div>
      <p class="theme-text font-medium text-2xl mt-9">Congratulations!</p>
      <p class="font-medium text-gray-700 mt-3" style="font-size: 17px">
        Your purchase was successful. Thank you!
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'payment-success',
  };
</script>

<style scoped></style>
